export var STInvoiceStatus;
(function (STInvoiceStatus) {
    STInvoiceStatus["Created"] = "Created";
    STInvoiceStatus["Prepared"] = "Prepared";
    STInvoiceStatus["Completed"] = "Completed";
    STInvoiceStatus["Canceled"] = "Canceled";
})(STInvoiceStatus || (STInvoiceStatus = {}));
//# sourceMappingURL=STInvoiceStatus.js.map